import { AnimatePresence, motion } from 'framer-motion'
import { useScene } from 'providers/SceneProvider'
import { FC } from 'react'

interface Props {
  page: number
  direction: number
  distance?: number
  showDescription?: boolean
  className?: string
  slideDirection?: 'horizontal' | 'vertical'
  handleSetPage?: (page: number) => void
}

const PartSelectorDisplay: FC<Props> = ({
  page,
  direction,
  showDescription = false,
  distance = 200,
  slideDirection = 'vertical',
  className,
  handleSetPage = () => {},
}) => {
  const { selectedSlide } = useScene()
  const variants = {
    initial: () => {
      return {
        y: slideDirection === 'vertical' ? (direction > 0 ? distance : -distance) : undefined,
        x: slideDirection === 'horizontal' ? (direction > 0 ? distance : -distance) : undefined,
        opacity: 0,
      }
    },
    center: {
      zIndex: 1,
      x: 0,
      y: 0,
      opacity: 1,
    },
    exit: (direction: number) => {
      return {
        zIndex: 0,
        y: slideDirection === 'vertical' ? (direction < 0 ? distance : -distance) : undefined,
        x: slideDirection === 'horizontal' ? (direction < 0 ? distance : -distance) : undefined,
        opacity: 0,
      }
    },
  }

  const handleClick = () => {
    handleSetPage(page)
  }

  return (
    <AnimatePresence custom={direction} initial={false}>
      <motion.div
        key={page}
        variants={variants}
        initial='initial'
        animate='center'
        exit='exit'
        transition={{
          y: slideDirection === 'vertical' ? { type: 'spring', stiffness: 100, damping: 20 } : null,
          x: slideDirection === 'horizontal' ? { type: 'spring', stiffness: 100, damping: 20 } : null,
          opacity: { duration: 0.2 },
        }}
        className={className}
      >
        <div className='absolute cursor-pointer select-none' onClick={handleClick}>
          <h4 className='uppercase text-sm font-semibold text-gray-800 whitespace-nowrap'>{selectedSlide?.title ?? 'Ingen del vald'}</h4>
          {showDescription && <p className='text-sm text-gray-300 w-[200px]'>{selectedSlide?.description}</p>}
        </div>
      </motion.div>
    </AnimatePresence>
  )
}

export default PartSelectorDisplay
